import { Navigate } from 'react-router-dom';

const RedirectToLiveChatItem = () => {
  return (
    <Navigate
      to="/live-chat"
      replace
    />
  );
};

export default RedirectToLiveChatItem;
